import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { functions } from '../functions/_functions';
import { withTheme } from '../core/theming';
import { PropTypesRepo } from '../functions/_propTypes';

import Icon from './Icon';
import Div from './Div';

const TITLE_MARGIN = '35px';

const HeaderStyled = withTheme(styled.header`
  ${(props) => props.pos && functions.makeResponsive('position', props.pos)};
  ${(props) => props.w && functions.makeResponsive('width', props.w)};
  ${(props) => props.zIndex && functions.makeResponsive('z-index', props.zIndex)};
  ${(props) => props.minH && functions.makeResponsive('min-height', props.minH)};
  ${(props) => props.h && functions.makeResponsive('height', props.h)};
  ${(props) => props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors)};
  ${(props) => props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor])};
  box-shadow: 5px 0 8px 0 rgba(0, 0, 0, 0.5);
`);

HeaderStyled.defaultProps = {
  pos: 'relative',
  w: '100%',
};

const Header = ({ mini, bg, textColor, onToggle, zIndex, rightChildren, theme, leftChildren, headerStyle }) => (
  <HeaderStyled
    bg={bg}
    textColor={textColor}
    zIndex={zIndex}
    minH={theme.application.headerHeight}
    h={theme.application.headerHeight}
    {...headerStyle}
  >
    <Div
      m={{ l: mini ? theme.application.miniMenuWidth : theme.application.menuWidth }}
      minH={theme.application.headerHeight}
      d="inline-flex"
      justify="flex-start"
      align="flex-start"
    >
      {mini ? (
        <Icon
          name="Next"
          color="shade99"
          cursor="pointer"
          pos="relative"
          hoverAnimation="right-shake"
          onClick={() => onToggle()}
        />
      ) : (
        <Icon
          name="Back"
          color="shade99"
          cursor="pointer"
          pos="relative"
          hoverAnimation="left-shake"
          onClick={() => onToggle()}
        />
      )}
    </Div>
    {leftChildren ? (
      <Div
        pos="absolute"
        top="0"
        left="0"
        m={{ l: `calc(${TITLE_MARGIN} + ${mini ? theme.application.miniMenuWidth : theme.application.menuWidth})` }}
        minH={theme.application.headerHeight}
        d="inline-flex"
        justify="flex-start"
        align="center"
      >
        {leftChildren}
      </Div>
    ) : null}
    {rightChildren ? (
      <Div
        pos="absolute"
        top="0"
        right="0"
        m={{ r: '26px' }}
        minH={theme.application.headerHeight}
        d="inline-flex"
        justify="flex-end"
        align="center"
      >
        {rightChildren}
      </Div>
    ) : null}
  </HeaderStyled>
);

Header.propTypes = {
  theme: PropTypes.shape({
    application: {},
  }).isRequired,
  mini: PropTypes.bool,
  bg: PropTypesRepo.bg,
  textColor: PropTypesRepo.textColor,
  onToggle: PropTypes.func,
  zIndex: PropTypes.string,
  rightChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  leftChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  headerStyle: PropTypes.shape({}),
};

Header.defaultProps = {
  mini: false,
  bg: 'white',
  textColor: 'brand500',
  onToggle: () => null,
  zIndex: '10',
  rightChildren: null,
  leftChildren: null,
  headerStyle: {},
};

export default withTheme(Header);
